import {
  closePopup,
  getPopupRegistration,
  openPopup,
  Priority
} from "app/PopupHolder";
import Modal from "components/base/Modal";
import React from "react";

import classNames from "classnames";
import css from "../style.scss";

import visaCard from "assets/images/account-page/visa-card.svg";
import { useState } from "react";
import { inferCardType } from "../../../utils/payment";
import { getLastFourDigits } from "../../../utils/validation";

const ChangeDefaultPaymentPopup = (props) => {

   const { image, name } = inferCardType(props?.cardNumber || "");

  const [selectedUsage, setSelectedUsage] = useState({
    none: false,
    subscriptions: false,
    inAppPurchases: false,
  });

  const handleClose = () => {
    props.closePopup();
  };

  const handleCheckboxChange = (selection) => {
    if (selection === 'none') {
      setSelectedUsage({
        subscriptions: false,
        inAppPurchases: false,
        [selection]: !selectedUsage[selection],
      });
    } else {
      setSelectedUsage({
        ...selectedUsage,
        none: false,
        [selection]: !selectedUsage[selection],
      });
    }
  }
    const updateDefaultPayment = async () => {
      // try {
      //   const response = await deleteWalletAPI(props.paymentMethodId);
      //   if (response.success) {
      //     console.log(`update wallet successful:`, response);
      //     dispatch(loadWalletList(userID));
      //     handleClose();
      //   } else {
      //     console.error(`update wallet failed:`, response.error);
      //   }
      // } catch (error) {
      //   console.error("Unexpected error:", error);
      // }
    };

  return (
    <Modal
      modalClassName={css.pricingModal}
      className={classNames(css.clsAccPageModals, css.clsBillingModal)}
      isOpen
      uniqId="MakeDefaultPaymentPopup"
      caption=""
      width="auto"
      padding="0px 0px 0px"
    >
      <div className={classNames(css.modal_lg, "modal-dialog modal-lg m-0")}>
        <div className={classNames(css.clsModalContent, "modal-content")}>
          <div className={classNames(css.clsModalContentBody, "modal-body")}>
          <div className={css.clsModalHeader}>
            <h2 className={css.clsModalTitle}>Make Default Payment Method?</h2>
            <h5 className={css.clsModalSubTitle}>
              Would you like to make this card the default payment method for Recurring Services and/or In-App Purchases
            </h5>
          </div>

            <div className={css.clsModalBody}>
              <div className={css.clsPayCard}>
              <img src={image} className="mr-3" alt={name} />
                <div className="clearfix">
                  <h5 className={css.clsMediaTxt1}>Ending in {getLastFourDigits(props?.cardNumber)}</h5>
                  <p className={css.clsMediaTxt2}>Exp. {props?.cardExp}</p>
                </div>
              </div>

              <div className="clearfix pt-5">
                <h4 className={classNames(css.clsModalSubTitle2, css.pb_20)}>Default Payment Usage</h4>
                <div className={classNames(css.clsDefaltPay, "row justify-content-center")}>
                   <div className="d-flex pt-4 col-10 align-items-center">
                    <div className={classNames(css.clsCustomCheckbox)}>
                      <input 
                        type="radio" 
                        id='radio1' 
                        name='default-payment'
                        checked={selectedUsage.none}
                        onChange={() => handleCheckboxChange('none')}
                      />
                      <label className={css.clsLabeltxtLine1} htmlFor="radio1">   None  </label>
                    </div>
                  </div>
                  <div className="d-flex pt-4 col-10 align-items-center">
                    <div className={css.clsCustomCheckbox}>
                      <input 
                        type="checkbox" 
                        id='checkbox1' 
                        name='default-payment'
                        checked={selectedUsage.subscriptions}
                        onChange={() => handleCheckboxChange('subscriptions')}
                      />
                      <div className={classNames(css.flex1, "clearfix")}>
                        <label className={css.clsLabeltxtLine1} htmlFor="checkbox1">Subscriptions</label>
                        <label className={classNames(css.clsLabeltxtLine1, css.clsLabeltxtLine2)} for="checkbox1">(Main Subscription, Lead Automator, and Team Members)</label>
                      </div>
                    </div> 
                  </div>
                  <div className="d-flex pt-4 col-10 align-items-center">
                  <div className={css.clsCustomCheckbox}>
                      <input 
                        type="checkbox" 
                        id='checkbox2' 
                        name='default-payment'
                        checked={selectedUsage.inAppPurchases}
                        onChange={() => handleCheckboxChange('inAppPurchases')}
                      />
                      <div className={classNames(css.flex1, "clearfix")}>
                        <label className={css.clsLabeltxtLine1} htmlFor="checkbox2">In App Purchases</label>
                        <label className={classNames(css.clsLabeltxtLine1, css.clsLabeltxtLine2)} for="checkbox2"> (Prepaid Credits, Skip-Tracing, Documents, and Marketing Purchases such as Postcards and Emails)</label>
                      </div>
                    </div>  
                  </div>
                </div>
              </div>
            </div>

            <div className={classNames(css.clsModalFooter)}>
              <button className={classNames(css.btn_lg, css.btn_primary, css.text_primary)} onClick={handleClose}> Cancel</button>
              <button className={classNames(css.btn_lg, css.clsBtnOrng)} onClick={updateDefaultPayment}>  Confirm and Save</button>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
};

const registrationId = getPopupRegistration(ChangeDefaultPaymentPopup);
ChangeDefaultPaymentPopup.open = (props = {}) =>
  openPopup(registrationId, { ...props, priority: Priority.MEDIUM });
ChangeDefaultPaymentPopup.close = () => closePopup({ popup: registrationId });

export default ChangeDefaultPaymentPopup;
